import HiggsPromise from '../../utils/higgsPromise';
import { HttpMethod } from '../../constants/enum';

/* 财务画像-公共-获取公司信息
 * POST请求, data为传递给后台的参数, 其他参数使用请查看HiggsPromise对象
*/
export function queryCompanyInfo(data) {
    return HiggsPromise({
        url: '/finance/portrait/company',
        type: HttpMethod.GET,
        data: data
    });
}



// WEBPACK FOOTER //
// ./src/services/financialPicture/common.js